import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'scroll-with-buttons',
  templateUrl: './scroll-with-buttons.component.html',
  styleUrls: ['./scroll-with-buttons.component.scss'],
  animations: [
    trigger('inOutfilter', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.2s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.2s ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('inOutbuttons', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.2s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('scrollAnimation', []),
  ],
})
export class ScrollWithButtonsComponent {
  @Input() showfilter = false;
  @Input() showright = false;
  @Input() showleft = false;
  showbutton = false;
  @ViewChild('filters', { read: ElementRef }) target: ElementRef;
  /**
   *scroll component
   *
   * @param {boolean} [right=true]
   * @memberof ScrollWithButtonsComponent
   */

  scroll(right = true) {
    if (this.showfilter) {
      if (right) {
        this.target.nativeElement.scrollLeft += 1000;
        this.showright = false;
      } else {
        this.target.nativeElement.scrollLeft -= 1000;
        this.showleft = false;
      }
    }
  }
  /**
   *show or no row
   *
   * @memberof ScrollWithButtonsComponent
   */
  inover(maxScrollLeft = 0) {
    !maxScrollLeft
      ? (maxScrollLeft =
          this.target.nativeElement.scrollWidth -
          this.target.nativeElement.clientWidth -
          10)
      : (maxScrollLeft = 100);
    if (maxScrollLeft > 0) {
      this.showbutton = true;
      if (
        this.target.nativeElement.scrollLeft > 10 &&
        this.target.nativeElement.scrollLeft < maxScrollLeft
      ) {
        this.showright = true;
        this.showleft = true;
      } else if (this.target.nativeElement.scrollLeft == 0) {
        this.showright = true;
        this.showleft = false;
      } else {
        this.showright = false;
        this.showleft = true;
      }
    } else {
      this.showbutton = false;
    }
  }
}
